<template>
  <gc-main-layout
    title="Sales Orders"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Sales Orders" :screenName="'Sales Orders - To Manifest'"/>
    </template>
    <div>
      <dx-data-grid
        :data-source="dataSourceConfig"
        :ref="gridRefName"
        :columns="columns"
        :selection="{
          mode: 'multiple',
          selectAllMode: 'allPages',
          showCheckBoxesMode: 'always',
        }"
        @selection-changed="onSelectionChanged"
        @toolbar-preparing="onToolbarPreparing($event)"
        :height="gridHeight"
        @content-ready="addGridNoResults($event)"
        :allow-column-reordering="false"
        :column-chooser="{ enabled: false }"
      >
        <dx-paging :enabled="false" />

        <template #date-in-cell-template="{ data }">
          <gc-friendly-date :date="data.data.ShipDate" />
        </template>

        <template #customer-cell-template="{ data }">
          <GcDescriptionCodeCellTemplate
            :description="data.data.CustomerName"
            :code="data.data.CustomerCode"
          />
        </template>

        <template #branch-cell-template="{ data }">
          <GcDescriptionCodeCellTemplate
            :description="data.data.BranchDescription"
            :code="data.data.BranchCode"
          />
        </template>

        <template #division-cell-template="{ data }">
          <GcDescriptionCodeCellTemplate
            :description="data.data.DivisionDescription"
            :code="data.data.DivisionCode"
          />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import { DeliveryConsignmentListService } from "../../_services/api/sales/delivery-consignment-list.service";
import { ManifestOrderService } from "../../_services/api/sales/manifest-order.service";
import BaseViewMixin from "../../v1/_mixins/base.view";
import { tabAccessControl } from "../../_helpers/access-control";

let ds = DeliveryConsignmentListService.dataSourceConfig(
  "api/DeliveryConsignmentList",
  {
    select: [
      "BranchDescription",
      "BranchCode",
      "DivisionDescription",
      "DivisionCode",
      "ConsignmentNo",
      "ConsignmentStatus",
      "CustomerName",
      "CustomerCode",
      "DeliveryAddressCompanyName",
      "OrderNo",
      "OrderSource",
      "SalesOrderCode",
      "ShipDate",
      "WebOrderNo",
    ],
    // sort: [{ selector: "SalesOrderCode", desc: true }],
    filter: [["ConsignmentStatus", "=", "Packed"]],
    preventPagination: true,
  }
);

function getConsignments(selectedRowsData) {
  const getConsignmentNo = ({ ConsignmentNo, OrderSource }) => ({
    ConsignmentNo,
    OrderSource,
  });
  return selectedRowsData.map(getConsignmentNo);
}

import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";

export default {
  props: {},
  mixins: [BaseViewMixin],
  watch: {
    $route: {
      immediate: true,
      handler: "handleTabRouteChange",
    },
  },
  data() {
    return {
      dataSourceConfig: [],
      payload: {},
      selectedRowKeys: [],
      gridRefName: "gridManifestOrder",
      noDataMessage: {
        addNew: {
          class: "hooray",
          title: "No Orders",
          message: "Your work is complete, all orders have been manifested.",
        },
      },
    };
  },
  components: {},
  computed: {
    columns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Sales Order",
          dataField: "SalesOrderCode",

          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
        },

        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          cellTemplate: "customer-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["CustomerCode", "CustomerName"],
        },

        {
          gcLabel: "Deliver To",
          dataField: "DeliveryAddressCompanyName",
          gcType: "String",
          width: 180,
        },
        {
          gcLabel: "Branch",
          dataField: "BranchDescription",
          cellTemplate: "branch-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["BranchCode", "BranchDescription"],
        },

        // {
        //   gcLabel: "Division",
        //   dataField: "DivisionDescription",
        //   cellTemplate: "division-cell-template",
        //   gcType: "String",
        //   gcSubType: "RelatedRecord",
        //   width: 220,
        //   gcExport: ["DivisionCode", "DivisionDescription"],
        // },
        {
          gcLabel: "Con Note",
          dataField: "ConsignmentNo",
          gcType: "String",
          width: 400,
        },
        // {
        //   gcLabel: "Order Source",
        //   dataField: "OrderSource",
        //   gcType: "String",
        //   minWidth: 200,
        // },
        {
          gcLabel: "Cust PO",
          dataField: "OrderNo",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(120),
        },

        {
          gcLabel: "Ship Date",
          dataField: "ShipDate",
          gcType: "Date",
        },
      ]);
    },

    tabs() {
      return tabAccessControl(SalesOrderTabs);
    },

    // END computed
  },
  methods: {
    handleTabRouteChange() {
      // this.selectedIndex = 0;
      this.selectedIndex = GetIndexByTabName("To Manifest");
    },
    onSelectionChanged({ selectedRowKeys, selectedRowsData }) {
      this.payload = { Consignments: getConsignments(selectedRowsData) };
      this.selectedRowKeys = selectedRowKeys;
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            onClick: this.refreshDataGrid.bind(this),
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "floppy",
            onClick: this.saveManifestOrder.bind(this),
          },
        }
      );
    },
    refreshDataGrid() {
      ds.load().then(() => {
        this.dataSourceConfig = ds.items();
      });
    },
    async saveManifestOrder() {
      this.$logger.trackEventButtonClickSave();
      if (this.validate()) {
        this.$refs[this.gridRefName].instance.beginCustomLoading();
        await ManifestOrderService.saveManifestOrder(this.payload)
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            // eslint-disable-next-line no-console
            // this.$logger.debug("saveCustomerAgent", res);
            this.$notify("Manifest order saved successfully", "success");
            this.refreshDataGrid();
          })
          .catch((error) => {
            this.displayServerError(error, "Manifest order save failed");
          })
          .finally(() => {
            this.$refs[this.gridRefName].instance.endCustomLoading();
          });
      } else {
        this.addErrorMessage("Atleast one order should be selected.");
        this.displayValidationSummary();
      }
    },
    validate() {
      return this.selectedRowKeys.length > 0;
    },
  },
  created() {
    this.refreshDataGrid();
  },
};
</script>

<style lang="scss"></style>
